<div class="auth-container">
  <mat-card class="auth-card">
    <mat-card-header>
      <mat-card-title>Passwort vergessen?</mat-card-title>
      @if (!message) {
        <mat-card-subtitle>Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen.</mat-card-subtitle>
      }
    </mat-card-header>

    <mat-card-content>
      @if (!message) {
        <form (ngSubmit)="requestReset()">
          <mat-form-field appearance="outline">
            <mat-label>E-Mail</mat-label>
            <mat-icon matPrefix>email</mat-icon>
            <input matInput [formControl]="emailControl" type="email" required />
          </mat-form-field>
          <button mat-flat-button color="accent" type="submit" [disabled]="emailControl.invalid">
            Link anfordern
          </button>
        </form>
      } @else {
        <div class="message-display success">
          <mat-icon>check_circle</mat-icon>
          <p>{{ message }}</p>
          <button mat-flat-button color="accent" type="submit" [routerLink]="'/login'"> Login </button>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
